
<template>
  <nav class="layout-footer footer" :class="getLayoutFooterBg()">
    <div
      class="
        container-fluid
        d-flex
        flex-wrap
        justify-content-between
        text-center
        container-p-x
        pb-3
      "
    >
      <div class="pt-3">
        <span class="footer-text">Copyright</span>
        <a href="http://www.snapon.it/" class="text-red-600 hover:text-red-700">
           © 2025 Snap-on Equipment.
        </a>
        <span class="footer-text">{{t("All rights reserved.")}}</span>
      </div>
    </div>

  </nav>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { Shop } from '@element-plus/icons-vue'
import { MenuIcon, XIcon } from '@heroicons/vue/outline'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'Footer',
  components: {
    Shop,
    XIcon,
    MenuIcon,
  },
  setup() {
    const { t } = useI18n()
    
    const getLayoutFooterBg = () => {
      return `bg-footer-theme`;
    }

    return {
      t,
      getLayoutFooterBg,
    }
  },
})
</script>


<style scoped>

</style>